import * as Yup from 'yup';
import { INVALID_FIELDS, YupString } from '.';
import { t } from 'i18next';

export const createSequencingSchemas = Yup.object().shape({
  sequencingPartnerId: YupString,
  sequencingTypeId: YupString,
});

export const orgCreateSequencingSchemas = createSequencingSchemas.shape({
  tenantId: YupString,
});

export const createUpdateSequencingPartnerSchema = Yup.object().shape({
  name: YupString,
  partnerAbbreviation: YupString,
});

export const createUpdateSequencingTypeSchema = Yup.object().shape({
  name: YupString,
  typeAbbreviation: YupString,
});

export const updateVolumeToSendOutSchema = Yup.array().of(
  Yup.object().shape({
    volumeToSendOut: Yup.number()
      .min(0, ({ min }) => t(INVALID_FIELDS.MIN_NUMBER, { number: min }))
      .max(1000000, ({ max }) => t(INVALID_FIELDS.MAX_NUMBER, { number: max }))
      .required(INVALID_FIELDS.REQUIRED),
  }),
);
